import { render } from "./CustomerSVG.vue?vue&type=template&id=08886b35"
import script from "./CustomerSVG.vue?vue&type=script&lang=js"
export * from "./CustomerSVG.vue?vue&type=script&lang=js"

import "./CustomerSVG.vue?vue&type=style&index=0&id=08886b35&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__